<div class="aa-search-select" [class.open]="open">
  <input #input class="aa-input aa-search-select-input" type="text" autocomplete="off" spellcheck="false"
    role="combobox" aria-autocomplete="list" [attr.aria-expanded]="open" [attr.aria-controls]="listId"
    [attr.aria-activedescendant]="open && highlighted >= 0 ? optionId(highlighted) : null"
    [id]="inputId || null" [disabled]="disabled" [value]="display"
    [placeholder]="open ? (value || placeholder) : (loading ? 'Loading…' : placeholder)"
    (focus)="openList()" (click)="openList()" (input)="onInput($any($event.target).value)"
    (keydown)="onKeydown($event)" (blur)="onBlur()" />
  <svg class="icon aa-search-select-chevron" aria-hidden="true"><use href="#icon-chevron-down"></use></svg>

  @if (open) {
    <!-- mousedown is cancelled so picking doesn't blur the box first -->
    <div #list class="aa-search-select-list" role="listbox" [id]="listId" (mousedown)="$event.preventDefault()">
      @for (o of filtered; track o.group + ':' + o.value; let i = $index) {
        @if (o.group === 'recent' && i === 0) {
          <div class="aa-search-select-group" role="presentation">Recent</div>
        }
        @if (o.group === 'pinned' && (i === 0 || filtered[i - 1].group !== 'pinned')) {
          <div class="aa-search-select-group" role="presentation">{{ pinnedLabel }}</div>
        }
        @if (o.group === 'main' && (i === 0 || filtered[i - 1].group !== 'main')) {
          <div class="aa-search-select-group" role="presentation">{{ mainLabel }}{{ query ? '' : ' (' + mainCount + ')' }}</div>
        }
        <div class="aa-search-select-option" role="option" [id]="optionId(i)"
          [class.highlighted]="i === highlighted" [class.selected]="o.value === value" [attr.aria-selected]="o.value === value"
          (mouseenter)="highlighted = i" (click)="pick(o.value)">
          <span class="label">
            @for (p of o.parts; track $index) {
              @if (p.hit) { <strong>{{ p.text }}</strong> } @else { {{ p.text }} }
            }
            @if (o.group === 'unknown' && unknownNote) {
              <span class="note"> {{ unknownNote }}</span>
            }
          </span>
          @if (notes[o.value]; as note) {
            <span class="note">{{ note }}</span>
          }
          @if (o.value === value) {
            <svg class="icon check" aria-hidden="true"><use href="#icon-check"></use></svg>
          }
        </div>
      } @empty {
        <div class="aa-search-select-empty">{{ loading ? 'Loading…' : 'Nothing matches "' + query + '"' }}</div>
      }
    </div>
  }
</div>
